import { render } from "./MenuSyncView.vue?vue&type=template&id=b4e2b3f4&scoped=true"
import script from "./MenuSyncView.vue?vue&type=script&lang=js"
export * from "./MenuSyncView.vue?vue&type=script&lang=js"

import "./MenuSyncView.vue?vue&type=style&index=0&id=b4e2b3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e2b3f4"]])

export default __exports__